import { IGetOrdersDTO, OrderStatus, PaymentStatus } from '@/models/order.model';
import { TOrderFiltersValues, OrderFiltersFields } from '../helpers/types';
import { StepType } from '@/models/step.model';

class GetOrdersDTO implements IGetOrdersDTO {
  address?: string;
  cursor?: string;
  step_name?: StepType;
  status?: OrderStatus;
  user?: string;
  created?: string;
  tripletex_order_number?: string;
  limit?: number;
  payment_status?: PaymentStatus;
  start_id?: string;
  start_sk?: string;

  constructor(values: TOrderFiltersValues) {
    this.status = values[OrderFiltersFields.STATUS];
    this.user = values[OrderFiltersFields.USER];
    this.tripletex_order_number = values[OrderFiltersFields.TRIPLETEX_ORDER_NUMBER];
    this.limit = values[OrderFiltersFields.LIMIT] ?? 30;
    this.address = values[OrderFiltersFields.ADDRESS];
    this.created = values[OrderFiltersFields.CREATED]?.toString();
    this.step_name = values[OrderFiltersFields.STEP_NAME];
    this.payment_status = values[OrderFiltersFields.PAYMENT_STATUS];
    this.step_name = values[OrderFiltersFields.STEP_NAME];
    this.cursor = values[OrderFiltersFields.CURSOR];
  }
}

export default GetOrdersDTO;
